import { MentoringsForm } from "@/components/MentoringsForm"
import { getCompanyById } from "../../services/companyService"
import {
  createMentoring,
  getAllMentoringsV2,
  updateMentoring,
} from "../../services/mentoringServices"
import { Company } from "@/types/company"
import { MentoringDataType } from "@/types/mentoring"
import { useEffect, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { Avatar, Button, Text } from "@/components/atoms"
import { cnpjMask } from "@/utils/masks"
import { useToast } from "@/hooks/useToast"

export const MentoringsFormPage = () => {
  const { id, companyId } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const location = useLocation()
  const [mentoring, setMentoring] = useState<MentoringDataType | undefined>()
  const [company, setCompany] = useState<Company | null>(null)
  const isEditMode = Boolean(id)
  const showToast = useToast()

  // const companyId = location.state?.companyId

  useEffect(() => {
    if (isEditMode) {
      getAllMentoringsV2({ mentoriaId: Number(id), empId: companyId }).then((response) => {
        setMentoring(response.data[0])
        setCompany(response.meta.empresa)
      })
    } else {
      getAllMentoringsV2({ emp_id: companyId }).then((response) => {
        setCompany(response.meta.empresa)
      })
    }
  }, [id, isEditMode])

  // useEffect(() => {
  //   if (companyId) {
  //     getCompanyById(companyId).then((response) => {
  //       setCompany(response.data)
  //     })
  //   }
  // }, [companyId])

  const handleSubmit = async (data: Partial<MentoringDataType>, file: File | null) => {
    const formData = new FormData()

    if (file) {
      formData.append("documento", file)
    }

    Object.keys(data).forEach((key) => {
      const value = data[key as keyof typeof data]
      if (value !== null && value !== undefined) {
        formData.append(key, String(value))
      }
    })

    formData.append("empId", companyId)

    if (isEditMode) {
      await updateMentoring(Number(id), formData)
        .then((response) => {
          showToast({
            message: response.data.message,
            variant: "success",
          })
          navigate("/mentorings")
        })
        .catch((error) => {
          showToast({
            message: error.response.data.message,
            variant: "error",
          })
        })
    } else {
      await createMentoring(formData)
        .then((response) => {
          showToast({
            message: response.data.message,
            variant: "success",
          })
          navigate("/mentorings")
        })
        .catch((error) => {
          showToast({
            message: error.response.data.message,
            variant: "error",
          })
        })
    }
    // navigate("/mentorings")
  }

  return (
    <div className="mx-auto max-w-[800px] p-4">
      <h1 className="mb-4 text-2xl font-bold">
        {isEditMode ? "Editar Mentoria" : "Nova Mentoria"}
      </h1>
      <div className="rounded-xl bg-dark-500 p-8">
        {company && (
          <div className="mb-8 flex gap-3">
            <div className="flex items-center gap-2">
              <Avatar
                alt={company.nomeFantasia}
                src={company.empLogoUrl}
              />
              <div>
                <Text>{company.nomeFantasia}</Text>
                <Text>{cnpjMask(company.cnpj)}</Text>
              </div>
            </div>
          </div>
        )}
        <MentoringsForm
          initialData={mentoring}
          onSubmit={handleSubmit}
          companyData={company}
        />
      </div>
      <div className="mt-4 flex justify-end gap-4">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
        >
          Cancelar
        </Button>
        <Button
          type="submit"
          form="mentoring-form"
        >
          {isEditMode ? "Salvar Alterações" : "Criar Mentoria"}
        </Button>
      </div>
    </div>
  )
}
